"use client";
import { useMemo as i } from "react";
/*! @license DOMPurify 3.2.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.6/LICENSE */
const d = {
  size: {
    prefix: "sizes",
    default: "sizesdefault",
    valueSelector: "default"
  },
  style: {
    prefix: "styles",
    default: "stylesdefault",
    valueSelector: "default"
  },
  theme: {
    prefix: "themes",
    default: "themesdefault",
    valueSelector: "default"
  }
}, y = ({
  styles: e,
  defaultClass: l,
  extendedStyles: t,
  selectors: s
}) => {
  let n = [];
  if (n.push(e[l]), s) {
    const r = c(
      d,
      s
    ), u = new Map(Object.entries(e));
    for (const a of Object.values(r)) {
      const f = u.get(`${a.prefix}${a.valueSelector}`) || (a.default ? e[a.default] : null);
      n.push(f);
    }
  }
  return t && (n = n.concat(t.filter(o))), n.filter(o).join(" ").trim();
}, o = (e) => e && typeof e == "string" && e.trim() !== "", c = (...e) => {
  const l = (t) => t && typeof t == "object";
  return e.reduce((t, s) => (s && Object.keys(s).forEach((n) => {
    const r = t[n], u = s[n];
    Array.isArray(r) && Array.isArray(u) ? t[n] = r.concat(...u) : l(r) && l(u) ? t[n] = c(r, u) : t[n] = u;
  }), t), {});
}, p = (e) => {
  if (e) {
    const l = /* @__PURE__ */ new Map(), { extendedAttributes: t } = e;
    for (const s in e)
      s !== "extendedAttributes" && l.set(`data-a-${s}`, e[s]);
    if (t)
      for (const s in t)
        l.set(`data-a-${s}`, t[s]);
    return Object.fromEntries(l);
  }
  return null;
}, x = (e) => p(e), h = (e, l, t) => {
  const s = /^(-|null|-null|null-|undefined|-undefined|undefined-|-)$/gi, n = (r) => {
    if (r) {
      const u = r.match(s);
      let a = r;
      return u && u.forEach((f) => {
        a = a.replace(f, "");
      }), a || null;
    }
    return null;
  };
  return l ? [l].filter((r) => r ?? null).join("-").replace(/\s/g, "-").trim().toLowerCase() : [n(t?.prefix), l ?? e, n(t?.suffix)].filter((r) => r ?? null).join("-").replace(/\s/g, "-").trim().toLowerCase();
}, j = ({
  styles: e,
  defaultClass: l,
  extendedStyles: t,
  selectors: s
}) => i(() => y({ styles: e, defaultClass: l, extendedStyles: t, selectors: s }), [e, l, s, t]);
export {
  x as r,
  h as s,
  j as u
};
//# sourceMappingURL=usePresentationClassWithSelectors.D1eQxrvf.js.map
